<template>
    <div>
        <b-button v-if="row && row.cliente && (row.cliente.ar_id == 7 || row.cliente.user_id == 7)"
            :variant="`${isDataMenorQue15Dias() ? 'success': 'outline-secondary'}`" @click.prevent="handleClick()"
            size="sm"><i class="fab fa-whatsapp"></i></b-button>
    </div>
</template>


<script>
import { mapState, mapMutations } from "vuex";
export default {
    props: {
        row: Object,
    },
    computed: {
        ...mapState('user', ['parceiro']),
        ...mapState('chat', ['client_id', 'isActive', 'visible'])
    },
    methods: {
        ...mapMutations('chat', ['setClient', 'setIsActive', 'setVisible']),

        handleClick() {
        this.setClient(this.row.cliente.id);
        this.setVisible(true);
        this.setIsActive(true);
    },

        isDataMenorQue15Dias() {


            if (this.row && this.row.cliente && this.row.cliente.whatsapp && this.row.cliente.room && this.row.cliente.room.room &&  this.row.cliente.room.room.updated_at) {

                var dataFornecida = this.row.cliente.room.room.updated_at;

                // Criar objeto Date a partir da string fornecida
                var dataFornecidaObj = new Date(dataFornecida);

                // Obter a data atual
                var dataAtual = new Date();

                // Calcular a diferença em milissegundos
                var diferencaEmMilissegundos = dataAtual - dataFornecidaObj ;

                // Converter a diferença para dias
                var diferencaEmDias = diferencaEmMilissegundos / (1000 * 60 * 60 * 24);

                // Verificar se a diferença é maior ou menor que 15 dias
                if (diferencaEmDias > 0 && diferencaEmDias <= 15) {
                    return true;
                } else if (diferencaEmDias < 0) {
                    return false;
                } else {
                    return false;
                }
            }
            return false;

        }
    }


}
</script>
